import { FullWidthSpace } from "melco-ui";
import {
  ControlcenterMelcoModelsLicenseCreateResponse,
  useFormSubmit,
} from "melco-shared-logic";
import { useLicenseManager } from "../../../hooks/licensemanager/useLicenseManager";
import { Formik, FormikHelpers } from "formik";
import { useQueryClient } from "react-query";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { DisplayCreateLicenseSummary } from "./DisplayCreateLicenseSummary";
import { CreateLicenseFormValueType } from "./CreateLicenseForm";
import { useState } from "react";

type CreateLicenseSummaryProps = {
  licenseFormValues?: CreateLicenseFormValueType;
  licenseDisplayValues: any;
  callbackFn: (
    obj: ControlcenterMelcoModelsLicenseCreateResponse | undefined
  ) => void;
  stepback: () => void;
};
export const CreateLicenseSummary: React.FC<CreateLicenseSummaryProps> = ({
  stepback,
  callbackFn,
  licenseFormValues,
  licenseDisplayValues,
}) => {
  const [disableCreateAndSendEmailButton, setDisableCreateAndSendEmailButton] =
    useState(false);
  const queryClient = useQueryClient();
  const queryKey = "create-querylicensemanage";


  const createLicenseAndSendEmail = useLicenseManager();

  const handleCreateLicense = async (
    values: any,
    formikHelpers: FormikHelpers<any>,
    options: {}
  ) => {
    /**
     *   As per requirement by default we have to show Don't assign license switch button off in UI
     * but for backend we have to send true value for it.
     * so we will flip the value , whatever is shown in UI
     * if switch button off then send true
     * if switch button on then send false
     */
    // debugger;
    //   //setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger)
    let newEntity: ControlcenterMelcoModelsLicenseCreateResponse | undefined =
      await createLicenseAndSendEmail({
        assign_license: !licenseFormValues?.assign_license,
        email_address: licenseFormValues?.email_address,
        product_code: licenseFormValues?.product_code ?? "",

        referral_code: "LICENSE_MANAGER",
        subscription_code: licenseFormValues?.subscription_code ?? "",
        version_id: licenseFormValues?.version_id ?? "",
        is_validate_only: false,
        language: licenseFormValues?.language,
        melco_customer_id: licenseFormValues?.melco_customer_id,
        subscription_start_date: licenseFormValues?.subscription_start_date,
        affiliate_code: licenseFormValues?.affiliate_code
      });
    //   //console.log("newEntity",newEntity)
    console.log(newEntity);
    setDisableCreateAndSendEmailButton(false);
    callbackFn(newEntity);
  };
  const onSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {
    setDisableCreateAndSendEmailButton(true);
    try {
      await onCreateSerialNumber(values, formikHelpers, {});
    } catch (e) {
      console.log("Exception create License summary ", e);
    } finally {
      setDisableCreateAndSendEmailButton(false);
    }
  };

  const formSubmitToCreateLicense = () => {
    return [
      async (values: any, formikHelpers: FormikHelpers<any>) => {
        //debugger;
        return handleCreateLicense(values, formikHelpers, {});
      },
      {
        //  translationPrefix: "licenses.basic.detail.Create",
        // translationOptions: {
        //   batchnumber: 1,
        //        },
        translationPrefix: ["licensemanager", "create"].join("."),
        onError: () => {
          // refetch entity from server
          queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onCreateSerialNumber = useFormSubmit(...formSubmitToCreateLicense());

  return (
    <FullWidthSpace direction="vertical" size="large">
      <Formik initialValues={{}} onSubmit={onSubmit} enableReinitialize>
        <div>
          <DirtyFormPrompt>
            <DisplayCreateLicenseSummary
              stepback={stepback}
              licenseDisplayValues={licenseDisplayValues}
              licenseFormValues={licenseFormValues}
              disableCreateAndSendEmailButton={disableCreateAndSendEmailButton}
            />
          </DirtyFormPrompt>
        </div>
      </Formik>
    </FullWidthSpace>
  );
};
